import loadable from '../../utilities/loadable'

export const Favorites = loadable(() => import('./Favorites/Favorites'))
